import { View } from 'web-mojo';

const MAX_EVENTS = 50;

export default class LockActivityFeedPanel extends View {
    constructor() {
        super();
        this.events = [];
        this._lockHandler = this._onLockEvent.bind(this);
    }

    onInit() {
        app.events.on('device:state_changed', this._lockHandler);
    }

    onDestroy() {
        app.events.off('device:state_changed', this._lockHandler);
    }

    _onLockEvent(data) {
        const entry = {
            id: Date.now(),
            timestamp: new Date(),
            deviceId: data.device_id,
            lockEngaged: data.lock_engaged,
            latchOpened: data.latch_opened,
            isOnline: data.is_online,
            lockName: data.lock_name || `Device ${data.device_id}`,
            operatorName: data.operator_name || null,
        };
        this.events.unshift(entry);
        if (this.events.length > MAX_EVENTS) {
            this.events = this.events.slice(0, MAX_EVENTS);
        }
        this.render();
    }

    onActionClear() {
        this.events = [];
        this.render();
    }

    _formatTime(date) {
        return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }

    set template(v) { this._t = v; }

    get template() {
        if (this.events.length === 0) {
            return `
                <div class="p-4 text-center text-muted">
                    <i class="bi bi-shield-lock fs-2 d-block mb-2"></i>
                    Waiting for lock events…
                    <div class="small mt-1">Events appear here in real time as operators use CamLock devices.</div>
                </div>
            `;
        }

        const rows = this.events.map(e => {
            const isLock = e.lockEngaged;
            const icon = isLock
                ? '<i class="bi bi-lock-fill text-danger"></i>'
                : '<i class="bi bi-unlock-fill text-success"></i>';
            const action = isLock ? 'LOCKED' : 'UNLOCKED';
            const latch = e.latchOpened ? '<span class="badge bg-warning text-dark ms-1 small">Latch opened</span>' : '';
            const offline = !e.isOnline ? '<span class="badge bg-danger ms-1 small">Offline</span>' : '';

            return `
                <div class="d-flex align-items-start gap-2 px-3 py-2 border-bottom">
                    <div class="pt-1">${icon}</div>
                    <div class="flex-grow-1">
                        <div class="small fw-semibold">${e.lockName} ${latch}${offline}</div>
                        ${e.operatorName ? `<div class="text-muted small">${e.operatorName}</div>` : ''}
                    </div>
                    <div class="text-muted small text-nowrap">
                        <span class="fw-semibold ${isLock ? 'text-danger' : 'text-success'}">${action}</span>
                        <div>${this._formatTime(e.timestamp)}</div>
                    </div>
                </div>
            `;
        }).join('');

        return `
            <div>
                <div class="px-3 py-2 border-bottom bg-light d-flex justify-content-between align-items-center">
                    <span class="small text-muted">${this.events.length} event${this.events.length !== 1 ? 's' : ''} · Live</span>
                    <button type="button" class="btn btn-sm btn-link text-muted p-0" data-action="clear">Clear</button>
                </div>
                ${rows}
            </div>
        `;
    }
}
